import React from 'react'
// import Data from './Json/Contact.json';
import Banner from "./components/Banner/Index";
import Enquiry from './components/Forms/Enquiry'
import WebContainer from './components/WebContainer/Index'
import Title from './components/Title/Index'
import { useEffect, useState } from 'react';
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "./Utils/useApi";

const Contact = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setloading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/contact_details.php`);
        setPageData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setloading(false);
      }
    };
    fetchData();
  }, []);
  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error) return <div>Error: An error occurred while fetching data</div>;
  if (!pageData) return null;
  const { bannerData, addresses } = pageData;
  return (
    <>
      {bannerData && <Banner Data={bannerData} />}
      <main>
        <WebContainer containerClass={'pt-5 mt-5 border-top float-end'} _parentClass={'ContactDetails'}>
          <Title firstHeading={'United Corp.'} secondHeading={'Contact Us'} />
          <div className='col-12 flaot-start'>
            <div className='row'>
              <div className='col-lg-4 col-sm-6 col-12 '>
                <div className='contactDetail'>
                  <span className='fs-2 fw-100'>T</span>
                  <p><a href={`tel:${addresses[0].phone}`}>{addresses[0].phone}</a></p>
                </div>
              </div>
              <div className='col-lg-4 col-sm-6 col-12 '>
                <div className='contactDetail'>
                  <span className='fs-2 fw-100'>E</span>
                  <p><a href={`mailto:${addresses[0].email}`}>{addresses[0].email}</a></p>
                </div>
              </div>
              <div className='col-lg-4 col-sm-6 col-12 '>
                <div className='contactDetail'>
                  <span className='fs-2 fw-100'>A</span>
                  <p dangerouslySetInnerHTML={{ __html: addresses[0].address }} />
                </div>
              </div>
            </div>
          </div>
        </WebContainer>
        <Enquiry />
      </main >
    </>
  )
}

export default Contact